export const commonIconList = [
  'icon-actifry',
  'icon-arrow-link',
  'icon-baidu',
  'icon-blender',
  'icon-cakefactory',
  'icon-circle',
  'icon-circle-filled',
  'icon-circle-filled-half',
  'icon-colissimo',
  'icon-companion',
  'icon-cookeo',
  'icon-cooking-duration',
  'icon-cookingconnect',
  'icon-delivery-express',
  'icon-delivery-standard',
  'icon-delivery-withdrawal-point',
  'icon-dot',
  'icon-douban',
  'icon-expand',
  'icon-facebook',
  'icon-ingredient',
  'icon-instagram',
  'icon-kitchenware',
  'icon-linkedin',
  'icon-locker',
  'icon-messenger',
  'icon-ok-ru',
  'icon-oney',
  'icon-oney-x3',
  'icon-oney-x4',
  'icon-optigrill',
  'icon-pause',
  'icon-pin',
  'icon-pin-brand',
  'icon-pin-filled',
  'icon-pinterest',
  'icon-prep-duration',
  'icon-program-duration',
  'icon-program-speed',
  'icon-program-temperature',
  'icon-program-type',
  'icon-qq',
  'icon-quote',
  'icon-qzone',
  'icon-reparability',
  'icon-rest-duration',
  'icon-seller-accessories',
  'icon-sina-weibo',
  'icon-snapchat',
  'icon-steamup',
  'icon-tiktok',
  'icon-tumblr',
  'icon-twitter',
  'icon-ups',
  'icon-vk',
  'icon-wechat',
  'icon-whatsapp',
  'icon-youtube',
  'icon-diameter',
  'icon-refurbished',
  'icon-new',
  'icon-check-circle-2',
  'icon-dash-circle',
  'icon-chrono',
  'icon-info'
];
